export const delay = async (miliseconds: number): Promise<null> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(null);
    }, miliseconds);
  });
};
